var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"success","outlined":""},on:{"click":function () { return _vm.action(); }}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-dog-side")]),_vm._v(" Fetch ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }